import {
    IStartPageSpinnerAction,
    IStartPresCreateSpinnerAction,
    IStartPresUpdateSpinnerAction,
    IStartWindowResizeSpinnerAction,
    IStopPageSpinnerAction,
    IStopPresCreateSpinnerAction,
    IStopPresUpdateSpinnerAction,
    IStopWindowResizeSpinnerAction,
} from './types/spinner.types';

export const START_PAGE_SPINNER = 'START_PAGE_SPINNER';
export const STOP_PAGE_SPINNER = 'STOP_PAGE_SPINNER';
export const START_PRES_UPDATE_SPINNER = 'START_PRES_UPDATE_SPINNER';
export const STOP_PRES_UPDATE_SPINNER = 'STOP_PRES_UPDATE_SPINNER';
export const START_PRES_CREATE_SPINNER = 'START_PRES_CREATE_SPINNER';
export const STOP_PRES_CREATE_SPINNER = 'STOP_PRES_CREATE_SPINNER';
export const START_WINDOW_RESIZE_SPINNER = 'START_WINDOW_RESIZE_SPINNER';
export const STOP_WINDOW_RESIZE_SPINNER = 'STOP_WINDOW_RESIZE_SPINNER';

export const startPageSpinnerAction = (mask?: boolean): IStartPageSpinnerAction => ({
    type: START_PAGE_SPINNER,
    mask,
});

export const stopPageSpinnerAction = (): IStopPageSpinnerAction => ({
    type: STOP_PAGE_SPINNER,
});

export const startPresUpdateSpinnerAction = (mask?: boolean): IStartPresUpdateSpinnerAction => ({
    type: START_PRES_UPDATE_SPINNER,
    mask,
});

export const stopPresUpdateSpinnerAction = (): IStopPresUpdateSpinnerAction => ({
    type: STOP_PRES_UPDATE_SPINNER,
});

export const startPresCreateSpinnerAction = (): IStartPresCreateSpinnerAction => ({
    type: START_PRES_CREATE_SPINNER,
});

export const stopPresCreateSpinnerAction = (): IStopPresCreateSpinnerAction => ({
    type: STOP_PRES_CREATE_SPINNER,
});

export const startWindowResizeSpinnerAction = (): IStartWindowResizeSpinnerAction => ({
    type: START_WINDOW_RESIZE_SPINNER,
});

export const stopWindowResizeSpinnerAction = (): IStopWindowResizeSpinnerAction => ({
    type: STOP_WINDOW_RESIZE_SPINNER,
});
